import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirlineSeatLegroomReducedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airline_seat_legroom_reduced"}/>
}
